import React, { useState, useEffect } from 'react';
import Rating from 'rating-react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { cleanSrcForJPG } from '@/helpers/imagesHelpers';

const NewIndividualCommentComponent = (props) => {
  const { name, lastname, main_image, stars, detail, extraClass, lenguage } = props;
  const [translatedText, setTranslatedText] = useState('');

  useEffect(() => {
    fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=es&tl=en&dt=t&q=${encodeURIComponent(
        detail,
      )}`,
    )
      .then((res) => res.json())
      .then((data) => {
        const translation = data[0]?.map((part) => part[0]).join('');
        setTranslatedText(translation);
      })
      .catch((err) => {
        console.error('Error al traducir', err);
      });
  }, []);

  let profileImage = '';
  try {
    const parsed = JSON.parse(main_image);
    if (Array.isArray(parsed) && parsed.length > 0) {
      profileImage = parsed[0];
    }
  } catch (err) {
    profileImage = main_image;
  }
  return (
    <FlexContainer className={'flex-column padtb10 ' + extraClass}>
      <FlexContainer className={'gap-16'}>
        {profileImage && (
          <img
            src={cleanSrcForJPG(profileImage)}
            alt={`${name} ${lastname}`}
            loading="lazy"
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginTop: '4px',
            }}
          />
        )}

        <FlexContainer className={'flex-column'}>
          <FlexContainer className={'text-8 align-center align-items-center'}>
            <Rating
              value={stars}
              size={'sm'}
              activeColor="#fffff"
              color="#fffff"
              disabled
              disabledOpacity={true}
            />
          </FlexContainer>
          <FlexContainer className={'gap-8 m-text-12 align-center'}>
            <strong>{`${name} ${lastname || ''}`} </strong>
            {lenguage === 'ES' ? ' | 14 de marzo 2025' : ' | March 14, 2025'}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      {detail && (
        <FlexContainer className={'text-14 margt6'}>
          {lenguage === 'ES' ? detail : translatedText}
        </FlexContainer>
      )}
      {!detail && <FlexContainer className={'text-14 margt6'}>{'Sin comentarios'}</FlexContainer>}
    </FlexContainer>
  );
};

const CommmentComponent = (props) => {
  const { spaceComment, lenguage, extraClass } = props;
  return (
    <FlexContainer
      className={
        'bgGrandientSkyBlue flex-column border-rad8px fontWhite m-flex-column padt20 padlr20 m-padlr20 padb20 ' +
        extraClass
      }
    >
      <FlexContainer className={' text-14 align-items-center justify-between'}>
        <strong>
          {lenguage === 'EN'
            ? '100% of Bookers Liked It'
            : 'Al 100% de los que reservaron les gustó'}
        </strong>
      </FlexContainer>
      <FlexContainer
        className={'text-14 align-items-center justify-between padb4 borderPurpleBottom'}
      >
        {spaceComment?.length + ' ' + (lenguage === 'EN' ? 'Ratings' : 'Valoraciones')}
      </FlexContainer>
      <FlexContainer className={'flex-column border-rad8px'}>
        {spaceComment?.length > 0 ? (
          spaceComment.map((comment, index) => (
            <NewIndividualCommentComponent
              key={index}
              lenguage={lenguage}
              name={comment.user_name}
              stars={comment.comment_stars}
              main_image={comment.main_image}
              lastname={comment.user_lastname}
              detail={comment.comment_detail}
              extraClass={index + 1 < spaceComment?.length ? 'borderPurpleBottom' : ''}
            />
          ))
        ) : (
          <Label className="text-16 width100 margtb20 text-justify">
            {lenguage === 'EN' ? 'No comments yet' : 'Aún no hay comentarios'}
          </Label>
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

export default CommmentComponent;
